import login from './login';

export default {
  language: 'de',
  country: 'de',
  name: 'Deutsch',
  embeddedLocale: login,
};
